import webvtt from 'node-webvtt';
import { FC, useEffect, useRef, useState } from 'react';

import * as Styled from './thumbnail.styles';

const timeToolipToSeconds = (time: string): number | undefined => {
  if (!time) return;
  const [s, m, h] = time.split(':').reverse();
  return parseInt(s) + parseInt(m) * 60 + (h ? parseInt(h) * 60 * 60 : 0);
};

const findCueFromVtt = (
  time: any,
  cueList: any
): {
  sprite: any;
  x: any;
  y: any;
  width: any;
  height: any;
} | null => {
  if (cueList && !isNaN(time)) {
    for (let i = 0; i < cueList.length; i++) {
      if (cueList[i].start <= time && cueList[i].end > time) {
        const [sprite, position] = cueList[i].text.split('#');
        const [x, y, width, height] = position.substring(5).split(',');
        return { sprite, x, y, width, height };
      }
    }
  }
  return null;
};

type Props = {
  timeToolipEl: any;
  vtt: any;
  vttSrc: string;
};
export const Thumbnail: FC<Props> = ({ timeToolipEl, vtt, vttSrc }) => {
  const observer = useRef<MutationObserver | null>(null);
  const [time, setTime] = useState<number | undefined>();

  useEffect(() => {
    observeTimeValue();
  }, []);

  const observeTimeValue = (): void => {
    if (observer.current) {
      return;
    }

    observer.current = new window.MutationObserver((mutations) => {
      mutations.forEach((mutation: any) => {
        setTime(timeToolipToSeconds(mutation.addedNodes[0].data));
      });
    });

    const observerConfig = {
      childList: true,
    };

    observer.current.observe(timeToolipEl, observerConfig);
  };

  const cue = findCueFromVtt(time, webvtt.parse(vtt));

  const thumbnailStyle = cue
    ? {
        width: cue.width + 'px',
        height: cue.height + 'px',
        left: '-' + cue.width / 2 + 'px',
        bottom: 'calc(' + cue.height + 'px + 1em)',
        background:
          'url(' +
          new URL('sprite_double.png', vttSrc).toString() +
          ') -' +
          cue.x +
          'px -' +
          cue.y +
          'px',
      }
    : {};

  return (
    <Styled.VideoThumbnail className="videoThumbnail" style={thumbnailStyle} />
  );
};
